import { ArrowDown } from "lucide-react";
import type { ReactNode } from "react";
import { FeaturedBank } from "./FeaturedBank";
import type { Lender } from "@/lib/lenders";

export function CategoryHero({
  headingBefore,
  underlined,
  headingAfter,
  subtitle,
  featuredLender,
  featuredTitle,
  featuredTitleHighlight,
  topListId = "toplist",
}: {
  headingBefore: string;
  underlined: string;
  headingAfter: string;
  subtitle: ReactNode;
  featuredLender: Lender;
  featuredTitle?: string;
  featuredTitleHighlight?: string;
  topListId?: string;
}) {
  return (
    <section className="relative overflow-hidden pb-14 pt-10 sm:pb-20 sm:pt-14">
      <div className="relative mx-auto grid max-w-7xl items-start gap-10 px-4 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:px-8">
        <div className="flex flex-col justify-start pt-2 lg:pt-6">
          <h1 className="text-balance font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-[3.2rem]">
            {headingBefore}{" "}
            <span className="underline-brand">{underlined}</span>
            {headingAfter ? <> {headingAfter}</> : null}
          </h1>
          <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-foreground/75 sm:text-base">
            {subtitle}
          </p>

          <a
            href={`#${topListId}`}
            className="mt-6 inline-flex w-fit items-center gap-2 rounded-md bg-primary px-6 py-3.5 text-base font-bold text-primary-foreground shadow-[0_10px_30px_-10px_color-mix(in_oklab,var(--primary)_60%,transparent)] transition-all hover:brightness-110"
          >
            Se hela topplistan <ArrowDown className="h-5 w-5" />
          </a>
        </div>

        <div className="relative">
          <FeaturedBank lender={featuredLender} title={featuredTitle} highlightWord={featuredTitleHighlight} compact />
        </div>
      </div>
    </section>
  );
}
